import IItemWithSignatureRaw from "../IItemWithSignatureRaw";
import ITrackableStock from "../ITrackableStock";
import Item from "./Item";
import Site from "./Site";

export default class Stock implements ITrackableStock, IItemWithSignatureRaw {
  constructor(
    public id: number,
    public site: Site,
    public item: Item,
    public quantity: number,
    public estimatedQuantity: number,
    public lot: string | undefined,
    public bestBefore: string | undefined,
    public expiry: string | undefined,
    public bestBeforeAsDate: Date | undefined,
    public expiryAsDate: Date | undefined,
    public bestBeforeExceeded: boolean,
    public expiryExceeded: boolean,
    public bestBeforeLeadTimeReached: boolean,
    public expiryLeadTimeReached: boolean,
    public modifiedQuantity: number | undefined
  ) {
  }
}
